import { defaultPageInfo } from '@/common/constants/ConstCode';
import { isEmpty } from '@/common/utils/Util';

export default {
  initFunerals: (state, flag = false) => {
    state.funerals = [];
    state.pageInfo.totalPage = 2;
    state.condition.page = 1;
    state.condition.limit = 10;
    state.condition.searchText = '';
    state.condition.searchFlag = flag;
    state.condition.userNo = '';
  },

  setFunerals: (state, list) => {
    if (isEmpty(state.funerals)) {
      state.funerals = list;
    } else {
      state.funerals = [...state.funerals, ...list];
    }
  },
  setObituaryList: (state, list) => {
    state.obituaryList = [...state.obituaryList, ...list];
  },
  setPageInfo(state, pageInfo) {
    state.pageInfo = pageInfo;
  },
  setAnnouncementPageInfo(state, pageInfo = defaultPageInfo) {
    state.announcementPageInfo = pageInfo;
  },
  setDetail: (state, data) => {
    Object.assign(state.detail, data);
  },
  setObituaryDetail: (state, data) => {
    Object.assign(state.obituaryDetail, data);
  },
  setCommentList: (state, list) => {
    state.detail.commentList = list || [];
  },
  setCondition: (state, condition) => {
    Object.assign(state.condition, condition);
  },
  setAnnouncementCondition: (state, condition) => {
    Object.assign(state.announcementCondition, condition);
  },
  detailInit: state => {
    for (let key in state.detail) {
      state.detail[key] = '';
    }
  }
};
